export function TeachingAffiliation() {
  return (
    <>
      Teaching Associate at{" "}
      <a href="https://www.henley.ac.uk/" rel="noreferrer noopener">
        Henley Business School
      </a>{" "}
      and{" "}
      <a href="https://www.sun.ac.za/" rel="noreferrer noopener">
        Stellenbosch University
      </a>
      .
    </>
  );
}

export const courses = [
  {
    slug: "ai",
    title: "AI",
    argument:
      "Prediction that an operator can still run. The useful question is whether someone who owns the outcome can still operate the system.",
    readings: [
      {
        to: "/thinking/prediction-has-to-operate",
        label: "Enterprise AI that cannot operate is a slide",
      },
      { to: "/work/ecosystem-ai", label: "ecosystem.Ai" },
    ],
  },
  {
    slug: "new-world-of-work",
    title: "New world of work",
    argument:
      "The changing world for the individual, the collective, and society — and how AI contributes to success.",
    readings: [
      { to: "/work/i4j", label: "Innovation for Jobs" },
      { to: "/resources/built-to-thrive", label: "Built to Thrive" },
    ],
  },
  {
    slug: "ai-and-behavior",
    title: "AI and behavior",
    argument:
      "Why people act, and what a model is allowed to assume about that action.",
    readings: [
      {
        to: "/research/human-behavioral-algorithms",
        label: "Human behavioral algorithms",
      },
      { to: "/#computational-social-science", label: "Computational social science" },
    ],
  },
] as const;
